import React, { useState } from 'react';

export default function NewInScanModern() {
  const [scanValue, setScanValue] = useState('');
  const [scanHistory, setScanHistory] = useState([]);

  const handleScan = () => {
    if (scanValue.trim()) {
      setScanHistory([{ code: scanValue, time: new Date().toLocaleString() }, ...scanHistory]);
      setScanValue('');
    }
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') handleScan();
  };

  return (
    <div style={{ padding: '32px', background: '#f6f8fb', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 28, fontWeight: 700, color: '#222', display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'inline-block', background: '#e9edfb', color: '#4f6af1', borderRadius: '8px', padding: '8px', marginRight: 14 }}>
            <i className="fa fa-barcode" style={{ fontSize: 20 }} />
          </span>
          InScan Lookup
        </div>
      </div>
      <div style={{ color: '#6b7280', fontSize: 15, marginBottom: 32 }}>
        Scan a code to look up InScan details
      </div>

      {/* Search/Scan Bar */}
      <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 4px rgba(0,0,0,0.04)', padding: 24, marginBottom: 32 }}>
        <div style={{ fontWeight: 600, color: '#4f6af1', marginBottom: 8 }}>Scanner Ready</div>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 14 }}>Scan with your scanner, or type the code manually</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <input
            type="text"
            value={scanValue}
            onChange={e => setScanValue(e.target.value)}
            onKeyDown={handleInputKeyDown}
            placeholder="Scan or enter code"
            style={{ flex: 1, padding: '14px 18px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, outline: 'none', background: '#f9fafb' }}
            autoFocus
          />
          <button
            onClick={handleScan}
            style={{ background: '#4f6af1', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <i className="fa fa-barcode" /> Scan
          </button>
        </div>
      </div>

      {/* Main Content Row */}
      <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
        {/* Ready to Scan Card */}
        <div style={{ flex: 2, minWidth: 340, background: '#fff', borderRadius: 14, padding: 32, minHeight: 260, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ fontSize: 44, color: '#d1d5db', marginBottom: 18 }}>
            <i className="fa fa-qrcode" />
          </div>
          <div style={{ fontWeight: 700, fontSize: 20, color: '#222', marginBottom: 8 }}>Ready to Scan</div>
          <div style={{ color: '#888', fontSize: 15, marginBottom: 18, textAlign: 'center' }}>
            Scan a code with your scanner, or type the code and press Enter
          </div>
          <div style={{ color: '#b0b4c1', fontSize: 13, marginTop: 10 }}>
            <span style={{ color: '#4f6af1', fontWeight: 600 }}>1</span> Connect scanner &nbsp;→&nbsp;
            <span style={{ color: '#4f6af1', fontWeight: 600 }}>2</span> Scan code &nbsp;→&nbsp;
            <span style={{ color: '#4f6af1', fontWeight: 600 }}>3</span> View results
          </div>
        </div>
        {/* Scan History Card */}
        <div style={{ flex: 1, minWidth: 260, background: '#fff', borderRadius: 14, padding: 32, minHeight: 260, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ fontWeight: 700, fontSize: 17, color: '#222', marginBottom: 18 }}>Scan History</div>
          {scanHistory.length === 0 ? (
            <div style={{ color: '#b0b4c1', fontSize: 15 }}>No scans yet</div>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {scanHistory.map((item, idx) => (
                <li key={idx} style={{ marginBottom: 14, borderBottom: '1px solid #f0f0f0', paddingBottom: 8 }}>
                  <div style={{ fontWeight: 600, color: '#4f6af1', fontSize: 15 }}>{item.code}</div>
                  <div style={{ color: '#888', fontSize: 12 }}>{item.time}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
